cb.define(['common/common_VM.Extend.js'], function(common) {
	//var _util = require('../../../helpers/util');

	var ST_st_storecheck_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			// 参数：是否珠宝行业
			var jewelleryIndustry = true;

			//条码扫描相关-------Begin-------------------------------------
			//初始化barcode
			common.initBarcodeModel(viewmodel);
			//扫码
			viewmodel.get("barcode").on('enter', function(data) {
				//字段对照
				var fields = {
					mainid: 'mainid',
					product: 'product',
					productcode: 'product_cCode',
					productname: 'product_cName',
					productsku: 'productsku',
					barcode: 'barcode',
					batchno: 'batchno',
					producedate: 'producedate',
					invaliddate: 'invaliddate',
					productskucode: 'productsku_cCode',
					weight: 'weight',
					quantity: 'quantity',
					unit: 'unit',
					unitname: 'unitName', //'unitName',
					accountWeight: 'accountWeight',
					accountPrice: 'skuSalePrice',
					isbatch: 'isBatchManage',
					isexpirydatemanage: 'isExpiryDateManage'
				};
				return common.onBarCodeEnter(data, viewmodel, fields);

				// return common.onBarCodeEnter(data, viewmodel, fields, afterBarcodeEnter);
			});
			//条码扫描相关-------End-------------------------------------

			/*
			viewmodel.addProperty("barcode", new cb.models.SimpleModel({
				"cFieldName": "barcode",
				"cItemName": "barcode",
				"iMaxLength": 255,
				"iFieldType": 1,
				"bEnum": false,
				"bMustSelect": false,
				"bHidden": true,
				"bSplit": false,
				"bExtend": false,
				"bCanModify": true,
				"iMaxShowLen": 255,
				"bNeedSum": false,
				"bShowIt": false,
				"bFilter": true,
				"bIsNull": true,
				"bPrintCaption": true,
				"bJointQuery": false,
				"bPrintUpCase": false,
				"bSelfDefine": false,
				"bMain": false,
				"cControlType": "Input"
			}));
			*/

			// ====== 共用变量 ======
			var self = this;
			var detailsModel = viewmodel.get("details");
			var planViewModel = null;
			var isBrowse = false;
			var curStatus = 0;

			viewmodel.on("afterLoadData", function(args) {
				// ====== 当前是否浏览态 ======
				isBrowse = viewmodel.getParams().mode === 'browse' ? true : false;

				// ====== 当前单据状态 ======
				let statusValue = viewmodel.get('status').getValue();
				if(!(null == statusValue || statusValue == undefined)) {
					curStatus = parseInt(statusValue);
				} else {
					curStatus = null;
				}

				planViewModel = viewmodel.getCache('parentViewModel').getCache('parentViewModel');

				// ====== 实盘单单据时间不得小于盘点计划开始时间 ======
				viewmodel.get('vouchdate').setState('min', planViewModel.get('vouchdate').getValue());

				// ====== 初始化单据日期 ======
				// viewmodel.get('vouchdate').setValue(new Date().format('yyyy-MM-dd hh:mm:ss'));

				// ====== 盘点范围、仓库、业务类型不允许修改 ======
				viewmodel.get('storeCheckRange').setDisabled('true');
				viewmodel.get("warehouse_name").setDisabled('true');
				viewmodel.get("businesstype_name").setDisabled('true');

				if(viewmodel.getParams().mode === 'add') {
					viewmodel.get('storecheckplan').setValue(planViewModel.get('id').getValue());
					viewmodel.get('storeCheckRange').setValue(planViewModel.get('storeCheckRange').getValue());

					viewmodel.get("warehouse").setValue(planViewModel.get('warehouse').getValue());
					viewmodel.get("warehouse_name").setValue(planViewModel.get('warehouse_name').getValue());
				}

				// ====== 浏览态 ======
				if(isBrowse) {
					// ====== 导入按钮不可见 ======
					viewmodel.get("btnAttachment").setVisible(false);
					viewmodel.get("btnAddDetail").setVisible(false);
					viewmodel.get("btnExport").setVisible(true);
				} else {
					viewmodel.get("btnExport").setVisible(false);
				}

				// ====== 直接隐藏帐存 ======
				detailsModel.setColumnState('accountQty', 'bShowIt', false);
				detailsModel.setColumnState('accountWeight', 'bShowIt', false);
				detailsModel.setColumnState('accountPrice', 'bShowIt', false);
				// ====== 需求目前决定：不显示帐存 End ======

				// ====== 已复核状态 ======
				if(curStatus == 1) {
					viewmodel.get("btnAddDetail").setVisible(false);
					viewmodel.get("btnAttachment").setVisible(false);
				}

				//查询是否为珠宝行业，如果是珠宝行业，那么不显示重量
				var isJewelleryIndustry = cb.rest.DynamicProxy.create({
					settle: {
						url: '/billingretail/isJewelleryIndustry',
						method: 'POST'
					}
				});
				isJewelleryIndustry.settle((err, result) => {
					if(err) {
						return;
					}

					if(result === undefined) {
						return;
					}

					jewelleryIndustry = result;

					// ====== 根据参数设置是否显示回收重量：define1 =====
					if(jewelleryIndustry) {
						detailsModel.setColumnState('define1', 'bShowIt', true);
					} else {
						detailsModel.setColumnState('define1', 'bShowIt', false);
					}
				});

			});

			// ====== 公共批次号管理 ======
			if(detailsModel) {
				//单元格编辑之前判断该行商品是否启用批次管理和效期管理
				detailsModel.on('rowColChange', function(args) {
					return common.bacthnoAndExpiryDateManage(args, detailsModel);
				});

				//天曼姐与蔡蔷沟通，批次属性1不维护，让用户自己输入
//				//如果是珠宝行业
//				if(jewelleryIndustry) {
//					//实盘重量变化以后，要更新批次属性1
//					detailsModel.on('afterCellValueChange', function(data) {
//						switch(data.cellName) {
//							case "weight":
//								{
//									this.setCellValue(data.rowIndex, 'define1', data.value);
//									break;
//								}
//						}
//
//					});
//
//					//珠宝行业，实盘单，批次属性1不允许修改
//					detailsModel.on('rowColChange', function(args) {
//						if(jewelleryIndustry && args.value.columnKey == 'define1') {
//							return false;
//						}
//					});
//				}

			}

			// ====== 点击 编辑 按钮进入编辑态隐藏 导出Excel ======
			viewmodel.on("afterEdit", function(args) {
				viewmodel.get("btnExport").setVisible(false);
			});

			// ====== 根据商品查询服务结果新增行数据 ======
			var appendNewRow = function(mainid, data, quantity = 1) {
				// let pData = data.data.recordList[0];
				let pData = data.data[0];
				let isBatchManage = pData.isBatchManage;
				let accountWeight = null;
				let batchno = null;
				let producedate = null;
				let invaliddate = null;
				let weight = null;

				if(!isBatchManage) {
					accountWeight = pData.productskus[0].sku_define1;
					weight = accountWeight;
				} else {
					batchno = pData.productskus[0].batchno;

					if(null != batchno && batchno != undefined) {
						producedate = pData.productskus[0].producedate;
						invaliddate = pData.productskus[0].invaliddate;
						let define1 = pData.productskus[0].batchno_define1;

						accountWeight = define1;
						weight = define1;
					}
				}

				detailsModel.appendRow({
					"mainid": mainid,
					"product": pData.productskus[0].product,
					"product_cCode": pData.cCode,
					"product_cName": pData.cName,
					"productsku": pData.productskus[0].skuId,
					"barcode": pData.productskus[0].barCode,
					"batchno": batchno,
					"producedate": producedate,
					"invaliddate": invaliddate,
					"productsku_cCode": pData.productskus[0].skuCode,
					"weight": weight,
					"quantity": quantity,
					"unit": pData.oUnitId,
					"unitName": pData.unitName,
					"accountWeight": accountWeight,
					"accountPrice": pData.productskus[0].skuSalePrice,
					"isBatchManage": isBatchManage,

					// ====== 商品规格 ======
					"free1": pData.productskus[0].free1 ? pData.productskus[0].free1 : null,
					"free2": pData.productskus[0].free2 ? pData.productskus[0].free2 : null,
					"free3": pData.productskus[0].free3 ? pData.productskus[0].free3 : null,
					"free4": pData.productskus[0].free4 ? pData.productskus[0].free4 : null,
					"free5": pData.productskus[0].free5 ? pData.productskus[0].free5 : null,
					"free6": pData.productskus[0].free6 ? pData.productskus[0].free6 : null,
					"free7": pData.productskus[0].free7 ? pData.productskus[0].free7 : null,
					"free8": pData.productskus[0].free8 ? pData.productskus[0].free8 : null,
					"free9": pData.productskus[0].free9 ? pData.productskus[0].free9 : null,
					"free10": pData.productskus[0].free10 ? pData.productskus[0].free10 : null,

					// ====== 批次属性 ======
					"define1": pData.productskus[0].batchno_define1 ? pData.productskus[0].batchno_define1 : null,
					"define2": pData.productskus[0].batchno_define2 ? pData.productskus[0].batchno_define2 : null,
					"define3": pData.productskus[0].batchno_define3 ? pData.productskus[0].batchno_define3 : null,
					"define4": pData.productskus[0].batchno_define4 ? pData.productskus[0].batchno_define4 : null,
					"define5": pData.productskus[0].batchno_define5 ? pData.productskus[0].batchno_define5 : null,
					"define6": pData.productskus[0].batchno_define6 ? pData.productskus[0].batchno_define6 : null,
					"define7": pData.productskus[0].batchno_define7 ? pData.productskus[0].batchno_define7 : null,
					"define8": pData.productskus[0].batchno_define8 ? pData.productskus[0].batchno_define8 : null,
					"define9": pData.productskus[0].batchno_define9 ? pData.productskus[0].batchno_define9 : null,
					"define10": pData.productskus[0].batchno_define10 ? pData.productskus[0].batchno_define10 : null,
					"define11": pData.productskus[0].batchno_define11 ? pData.productskus[0].batchno_define11 : null,
					"define12": pData.productskus[0].batchno_define12 ? pData.productskus[0].batchno_define12 : null,
					"define13": pData.productskus[0].batchno_define13 ? pData.productskus[0].batchno_define13 : null,
					"define14": pData.productskus[0].batchno_define14 ? pData.productskus[0].batchno_define14 : null,
					"define15": pData.productskus[0].batchno_define15 ? pData.productskus[0].batchno_define15 : null,
					"define16": pData.productskus[0].batchno_define16 ? pData.productskus[0].batchno_define16 : null,
					"define17": pData.productskus[0].batchno_define17 ? pData.productskus[0].batchno_define17 : null,
					"define18": pData.productskus[0].batchno_define18 ? pData.productskus[0].batchno_define18 : null,
					"define19": pData.productskus[0].batchno_define19 ? pData.productskus[0].batchno_define19 : null,
					"define20": pData.productskus[0].batchno_define20 ? pData.productskus[0].batchno_define20 : null,
					"define21": pData.productskus[0].batchno_define21 ? pData.productskus[0].batchno_define21 : null,
					"define22": pData.productskus[0].batchno_define22 ? pData.productskus[0].batchno_define22 : null,
					"define23": pData.productskus[0].batchno_define23 ? pData.productskus[0].batchno_define23 : null,
					"define24": pData.productskus[0].batchno_define24 ? pData.productskus[0].batchno_define24 : null,
					"define25": pData.productskus[0].batchno_define25 ? pData.productskus[0].batchno_define25 : null,
					"define26": pData.productskus[0].batchno_define26 ? pData.productskus[0].batchno_define26 : null,
					"define27": pData.productskus[0].batchno_define27 ? pData.productskus[0].batchno_define27 : null,
					"define28": pData.productskus[0].batchno_define28 ? pData.productskus[0].batchno_define28 : null,
					"define29": pData.productskus[0].batchno_define29 ? pData.productskus[0].batchno_define29 : null,
					"define30": pData.productskus[0].batchno_define30 ? pData.productskus[0].batchno_define30 : null
				})
			};

			// ====== 根据商品查询服务结果修改行数据 ======
			var updateCurrentRow = function(curRowIndex, mainid, data, quantity = 1) {
				let pData = data.data[0];
				let isBatchManage = pData.isBatchManage;
				let accountWeight = null;
				let batchno = null;
				let producedate = null;
				let invaliddate = null;
				let weight = null;

				if(!isBatchManage) {
					accountWeight = pData.productskus[0].sku_define1;
					weight = accountWeight;
				} else {
					batchno = pData.productskus[0].batchno;

					if(null != batchno && batchno != undefined) {
						producedate = pData.productskus[0].producedate;
						invaliddate = pData.productskus[0].invaliddate;
						let define1 = pData.productskus[0].batchno_define1;

						accountWeight = define1;
						weight = define1;
					}
				}

				detailsModel.updateRow(curRowIndex, {
					"mainid": mainid,
					"product": pData.productskus[0].product,
					"product_cCode": pData.cCode,
					"product_cName": pData.cName,
					"productsku": pData.productskus[0].skuId,
					"barcode": pData.productskus[0].barCode,
					"batchno": batchno,
					"producedate": producedate,
					"invaliddate": invaliddate,
					"productsku_cCode": pData.productskus[0].skuCode,
					"weight": weight,
					"quantity": quantity,
					"unit": pData.oUnitId,
					"unitName": pData.unitName,
					"accountWeight": accountWeight,
					"accountPrice": pData.productskus[0].skuSalePrice,
					"isBatchManage": isBatchManage,

					"free1": pData.productskus[0].free1 ? pData.productskus[0].free1 : null,
					"free2": pData.productskus[0].free2 ? pData.productskus[0].free2 : null,
					"free3": pData.productskus[0].free3 ? pData.productskus[0].free3 : null,
					"free4": pData.productskus[0].free4 ? pData.productskus[0].free4 : null,
					"free5": pData.productskus[0].free5 ? pData.productskus[0].free5 : null,
					"free6": pData.productskus[0].free6 ? pData.productskus[0].free6 : null,
					"free7": pData.productskus[0].free7 ? pData.productskus[0].free7 : null,
					"free8": pData.productskus[0].free8 ? pData.productskus[0].free8 : null,
					"free9": pData.productskus[0].free9 ? pData.productskus[0].free9 : null,
					"free10": pData.productskus[0].free10 ? pData.productskus[0].free10 : null,

					// ====== 批次属性 ======
					"define1": pData.productskus[0].batchno_define1 ? pData.productskus[0].batchno_define1 : null,
					"define2": pData.productskus[0].batchno_define2 ? pData.productskus[0].batchno_define2 : null,
					"define3": pData.productskus[0].batchno_define3 ? pData.productskus[0].batchno_define3 : null,
					"define4": pData.productskus[0].batchno_define4 ? pData.productskus[0].batchno_define4 : null,
					"define5": pData.productskus[0].batchno_define5 ? pData.productskus[0].batchno_define5 : null,
					"define6": pData.productskus[0].batchno_define6 ? pData.productskus[0].batchno_define6 : null,
					"define7": pData.productskus[0].batchno_define7 ? pData.productskus[0].batchno_define7 : null,
					"define8": pData.productskus[0].batchno_define8 ? pData.productskus[0].batchno_define8 : null,
					"define9": pData.productskus[0].batchno_define9 ? pData.productskus[0].batchno_define9 : null,
					"define10": pData.productskus[0].batchno_define10 ? pData.productskus[0].batchno_define10 : null,
					"define11": pData.productskus[0].batchno_define11 ? pData.productskus[0].batchno_define11 : null,
					"define12": pData.productskus[0].batchno_define12 ? pData.productskus[0].batchno_define12 : null,
					"define13": pData.productskus[0].batchno_define13 ? pData.productskus[0].batchno_define13 : null,
					"define14": pData.productskus[0].batchno_define14 ? pData.productskus[0].batchno_define14 : null,
					"define15": pData.productskus[0].batchno_define15 ? pData.productskus[0].batchno_define15 : null,
					"define16": pData.productskus[0].batchno_define16 ? pData.productskus[0].batchno_define16 : null,
					"define17": pData.productskus[0].batchno_define17 ? pData.productskus[0].batchno_define17 : null,
					"define18": pData.productskus[0].batchno_define18 ? pData.productskus[0].batchno_define18 : null,
					"define19": pData.productskus[0].batchno_define19 ? pData.productskus[0].batchno_define19 : null,
					"define20": pData.productskus[0].batchno_define20 ? pData.productskus[0].batchno_define20 : null,
					"define21": pData.productskus[0].batchno_define21 ? pData.productskus[0].batchno_define21 : null,
					"define22": pData.productskus[0].batchno_define22 ? pData.productskus[0].batchno_define22 : null,
					"define23": pData.productskus[0].batchno_define23 ? pData.productskus[0].batchno_define23 : null,
					"define24": pData.productskus[0].batchno_define24 ? pData.productskus[0].batchno_define24 : null,
					"define25": pData.productskus[0].batchno_define25 ? pData.productskus[0].batchno_define25 : null,
					"define26": pData.productskus[0].batchno_define26 ? pData.productskus[0].batchno_define26 : null,
					"define27": pData.productskus[0].batchno_define27 ? pData.productskus[0].batchno_define27 : null,
					"define28": pData.productskus[0].batchno_define28 ? pData.productskus[0].batchno_define28 : null,
					"define29": pData.productskus[0].batchno_define29 ? pData.productskus[0].batchno_define29 : null,
					"define30": pData.productskus[0].batchno_define30 ? pData.productskus[0].batchno_define30 : null
				})
			};

			var findRow = function(productsku, isBatchManage, batchNo = '_invalid_value_') {
				var rowIndex = -1;
				var rows = detailsModel.getRows();
				var rowLength = rows.length;

				for(var i = 0; i < rowLength; i++) {
					if(rows[i]._status == 'Delete') {
						continue;
					}

					if(productsku == detailsModel.getCellValue(i, 'productsku')) {
						if(isBatchManage) {
							if(batchNo == detailsModel.getCellValue(i, 'batchno')) {
								rowIndex = i;
								break;
								// } else {
								// 	if(batchNo == '_invalid_value_') {
								// 		rowIndex = i;
								// 	}
							}
						} else {
							if(detailsModel.getCellValue(i, 'batchno') == undefined) {
								rowIndex = i;
								break;
							}
						}
					}
				}

				return rowIndex;
			};

			viewmodel.on('beforeSave', function(args) {
				// ====== 实盘时间不得小于计划时间 ======
				var planCheckStartDate = planViewModel.get('checkStartTime').getValue();
				var realityDate = viewmodel.get("vouchdate").getValue();

				var minDate = Date.parse(planCheckStartDate);
				var thisDate = Date.parse(realityDate);

				if(null != thisDate && minDate > thisDate) {
					cb.utils.alert('单据的业务时间不得小于盘点计划开始时间', 'warning');
					return false;
				}

				//将盘点计划表体中的账面数量、账面重量、账面价格带上
				var plandetails = viewmodel.getCache('parentViewModel').getCache('parentViewModel').get('details').getRows();
				var originMap = {}; //sku+批号作为key，账面数量作为value
				if(plandetails != null && plandetails != undefined && plandetails !== '' && plandetails.length > 0) {
					for(var i = 0; i < plandetails.length; i++) {
						var plandetail = plandetails[i];
						var key = '';
						if(plandetail.productsku != null && plandetail.productsku != undefined && plandetail.productsku !== '') {
							key = key + plandetail.productsku;
						}
						if(plandetail.batchno != null && plandetail.batchno != undefined && plandetail.batchno !== '') {
							key = key + plandetail.batchno;
						}
						var qtykey = 'qty' + key;
						var qtyvalue = plandetail.accountQty;
						originMap[qtykey] = qtyvalue;

						var wgtkey = 'wgt' + key;
						var wgtvalue = plandetail.accountWeight;
						originMap[wgtkey] = wgtvalue;

						var pricekey = 'price' + key;
						var pricevalue = plandetail.accountPrice;
						originMap[pricekey] = pricevalue;
					}
				}

				var dataObj = JSON.parse(args.data.data);
				var realdetailsJsonObject = dataObj.details;
				if(realdetailsJsonObject != null && realdetailsJsonObject != undefined && realdetailsJsonObject !== '' && realdetailsJsonObject.length > 0) {
					for(var i = 0; i < realdetailsJsonObject.length; i++) {
						var realdetail = realdetailsJsonObject[i];
						var key = '';
						if(realdetail.productsku != null && realdetail.productsku != undefined && realdetail.productsku !== '') {
							key = key + realdetail.productsku;
						}
						if(realdetail.batchno != null && realdetail.batchno != undefined && realdetail.batchno !== '') {
							key = key + realdetail.batchno;
						}

						var qtykey = 'qty' + key;
						if(originMap[qtykey] != null && originMap[qtykey] != undefined && originMap[qtykey] !== '') {
							realdetail['accountQty'] = originMap[qtykey];
						}
						var wgtkey = 'wgt' + key;
						if(originMap[wgtkey] != null && originMap[wgtkey] != undefined && originMap[wgtkey] !== '') {
							realdetail['accountWeight'] = originMap[wgtkey];
						}
						var pricekey = 'price' + key;
						if(originMap[pricekey] != null && originMap[pricekey] != undefined && originMap[pricekey] !== '') {
							realdetail['accountPrice'] = originMap[pricekey];
						}
						//						if(jewelleryIndustry
						//							&& realdetail['batchno'] != null && realdetail['batchno'] != undefined && realdetail['batchno'] !== ''
						//							&& (realdetail['define1'] == null || realdetail['define1'] == undefined)
						//							&& (realdetail['weight'] != null && realdetail['weight'] != undefined && realdetail['weight'] !== '')
						//						) {
						//							realdetail['define1'] = realdetail['weight'];
						//						}
					}
				}
				args.data.data = JSON.stringify(dataObj);
			});

			// ====== 扫码业务逻辑 ======
			// ====== 2018-04-09 启用公共扫码逻辑，此处注释掉 ======
			/*
			viewmodel.get("barcode").on('enter', function(data) {
				var curMainId = viewmodel.get("id").getValue();
				var curIuputValue = data ? data : viewmodel.get("barcode").getValue();

				var queryProductProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/bill/ref/getBarcodeResult.do',
						method: 'POST'
					}
				});
				var params = {
					isReturn: 0,
					keyword: curIuputValue
				};

				if(curIuputValue && detailsModel) {
					queryProductProxy.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined || JSON.stringify(result) == "{}") {
							cb.utils.alert("条码/商品/SKU/批次 [" + curIuputValue + "] 无法解析！", 'error');
							return;
						}

            let pData = result.data[0];
						let isBatchManage = pData.isBatchManage;
						let resultSku = pData.productskus["0"].skuId;
						let batchno = isBatchManage ? pData.productskus[0].batchno : "_invalid_value_";

						if(isWithinRange(pData, 'productQueryService')) {
							var targetRow = findRow(resultSku, isBatchManage, batchno);

							if(targetRow != -1) {
								let newQuantity = null;
								let tempQty = detailsModel.getCellValue(targetRow, 'quantity');

								if(null == tempQty || tempQty === undefined) {
									newQuantity = 1;
								} else {
									newQuantity = parseFloat(tempQty) + 1;
								}

								detailsModel.setCellValue(targetRow, "quantity", newQuantity, false, false);
							} else {
								appendNewRow(curMainId, result);
							}
						}
					});
				}

				viewmodel.get("barcode").setValue(null);
			});
			*/

			detailsModel.on('afterCellValueChange', function(data) {
				var curRowIndex = data.rowIndex;

				switch(data.cellName) {
					// ====== 检查实盘数量为正数 ======
					case "quantity":
						{
							// var reg = /^[1-9]\d*$/;
							// var reg = /^\d+$/;
							var value = data.value;

							// if(!reg.test(value)) {
							if(value < 0) {
								cb.utils.alert("实盘数量只允许输入正数！", "warning");
								detailsModel.setCellValue(data.rowIndex, 'quantity', null);
								return false;
							}

							break;
						}

						// ====== 检查实盘重量必需大于0 ======
					case "weight":
						{
							var value = data.value;

							if(value < 0) {
								cb.utils.alert("实盘重量必需大于等于0！", "warning");
								detailsModel.setCellValue(data.rowIndex, 'weight', null);
								return false;
							}

							break;
						}

						// ====== 检查实盘重量必需大于0 ======
					case "price":
						{
							var value = data.value;

							if(value < 0) {
								cb.utils.alert("实盘价格必需大于等于0！", "warning");
								detailsModel.setCellValue(data.rowIndex, 'price', null);
								return false;
							}

							break;
						}

					case "product_cCode":
						{
							if(isWithinRange(data.value)) {
								let curProductsku = detailsModel.getCellValue(curRowIndex, 'productsku');
								let isBatchManage = detailsModel.getCellValue(curRowIndex, 'isBatchManage');
								let batchno = isBatchManage ? detailsModel.getCellValue(curRowIndex, 'batchno') : "_invalid_value_";

								detailsModel.setCellValue(curRowIndex, 'batchno', null);
								detailsModel.setCellValue(curRowIndex, 'producedate', null);
								detailsModel.setCellValue(curRowIndex, 'invaliddate', null);
								detailsModel.setCellValue(curRowIndex, 'define1', null);
								detailsModel.setCellValue(curRowIndex, 'define2', null);
								detailsModel.setCellValue(curRowIndex, 'define3', null);
								detailsModel.setCellValue(curRowIndex, 'define4', null);
								detailsModel.setCellValue(curRowIndex, 'define5', null);
								detailsModel.setCellValue(curRowIndex, 'define6', null);
								detailsModel.setCellValue(curRowIndex, 'define7', null);
								detailsModel.setCellValue(curRowIndex, 'define8', null);
								detailsModel.setCellValue(curRowIndex, 'define9', null);
								detailsModel.setCellValue(curRowIndex, 'define10', null);
								detailsModel.setCellValue(curRowIndex, 'define11', null);
								detailsModel.setCellValue(curRowIndex, 'define12', null);
								detailsModel.setCellValue(curRowIndex, 'define13', null);
								detailsModel.setCellValue(curRowIndex, 'define14', null);
								detailsModel.setCellValue(curRowIndex, 'define15', null);
								detailsModel.setCellValue(curRowIndex, 'define16', null);
								detailsModel.setCellValue(curRowIndex, 'define17', null);
								detailsModel.setCellValue(curRowIndex, 'define18', null);
								detailsModel.setCellValue(curRowIndex, 'define19', null);
								detailsModel.setCellValue(curRowIndex, 'define20', null);
								detailsModel.setCellValue(curRowIndex, 'define21', null);
								detailsModel.setCellValue(curRowIndex, 'define22', null);
								detailsModel.setCellValue(curRowIndex, 'define23', null);
								detailsModel.setCellValue(curRowIndex, 'define24', null);
								detailsModel.setCellValue(curRowIndex, 'define25', null);
								detailsModel.setCellValue(curRowIndex, 'define26', null);
								detailsModel.setCellValue(curRowIndex, 'define27', null);
								detailsModel.setCellValue(curRowIndex, 'define28', null);
								detailsModel.setCellValue(curRowIndex, 'define29', null);
								detailsModel.setCellValue(curRowIndex, 'define30', null);

								let targetRowIndex = findRow(curProductsku, isBatchManage, batchno);

								if(targetRowIndex != -1 && targetRowIndex != curRowIndex) {
									cb.utils.alert("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行！取消本次录入并跳转至已存在的行！", 'error');

									detailsModel.deleteRows([curRowIndex]);
									detailsModel.select([targetRowIndex]);
								}
							} else {
								detailsModel.deleteRows([curRowIndex]);
							}

							break;
						}
						// ====== 输入批次号后的业务处理逻辑 ======
					case "batchno":
						{
							let curProductsku = detailsModel.getCellValue(curRowIndex, 'productsku');
							let batchno = detailsModel.getCellValue(curRowIndex, 'batchno');

							let targetRowIndex = findRow(curProductsku, true, batchno);

							if(targetRowIndex != -1 && targetRowIndex != curRowIndex) {
								cb.utils.alert("发现已存在的行数据：第" + parseInt(targetRowIndex + 1) + "行！", "warning");
								detailsModel.deleteRows([curRowIndex]);
								detailsModel.select([targetRowIndex]);
							} else {
                var queryProductProxy = cb.rest.DynamicProxy.create({
                  settle: {
                    url: '/bill/ref/getBarcodeResult.do',
                    method: 'POST'
                  }
                });
                var params = {
                  isReturn: 0,
                  keyword: batchno
                };

                queryProductProxy.settle(params, (err, result) => {
                  if(err) {
                    cb.utils.alert(err.message, 'error');
                    return;
                  }

                  if(result === undefined || JSON.stringify(result) == "{}") {
                    cb.utils.alert("录入的批次 [" + batchno + "] 无法解析！", 'error');
                    return;
                  }

                  let pData = result.data[0];
                  let resultSku = pData.productskus["0"].skuId;
                  let resultBatchno = pData.productskus[0].batchno;

                  if(null != resultBatchno && resultBatchno != undefined) {
                    if (resultSku == curProductsku && resultBatchno == batchno) {
                      let producedate = pData.productskus[0].producedate;
                      let invaliddate = pData.productskus[0].invaliddate;
                      let define1 = pData.productskus[0].batchno_define1;
                      let define2 = pData.productskus[0].batchno_define2;
                      let define3 = pData.productskus[0].batchno_define3;
                      let define4 = pData.productskus[0].batchno_define4;
                      let define5 = pData.productskus[0].batchno_define5;
                      let define6 = pData.productskus[0].batchno_define6;
                      let define7 = pData.productskus[0].batchno_define7;
                      let define8 = pData.productskus[0].batchno_define8;
                      let define9 = pData.productskus[0].batchno_define9;
                      let define10 = pData.productskus[0].batchno_define10;
                      let define11 = pData.productskus[0].batchno_define11;
                      let define12 = pData.productskus[0].batchno_define12;
                      let define13 = pData.productskus[0].batchno_define13;
                      let define14 = pData.productskus[0].batchno_define14;
                      let define15 = pData.productskus[0].batchno_define15;
                      let define16 = pData.productskus[0].batchno_define16;
                      let define17 = pData.productskus[0].batchno_define17;
                      let define18 = pData.productskus[0].batchno_define18;
                      let define19 = pData.productskus[0].batchno_define19;
                      let define20 = pData.productskus[0].batchno_define20;
                      let define21 = pData.productskus[0].batchno_define21;
                      let define22 = pData.productskus[0].batchno_define22;
                      let define23 = pData.productskus[0].batchno_define23;
                      let define24 = pData.productskus[0].batchno_define24;
                      let define25 = pData.productskus[0].batchno_define25;
                      let define26 = pData.productskus[0].batchno_define26;
                      let define27 = pData.productskus[0].batchno_define27;
                      let define28 = pData.productskus[0].batchno_define28;
                      let define29 = pData.productskus[0].batchno_define29;
                      let define30 = pData.productskus[0].batchno_define30;
                      let accountWeight = define1;
                      let weight = define1;

                      detailsModel.setCellValue(curRowIndex, 'producedate', producedate);
                      detailsModel.setCellValue(curRowIndex, 'invaliddate', invaliddate);
                      detailsModel.setCellValue(curRowIndex, 'accountWeight', accountWeight);
                      detailsModel.setCellValue(curRowIndex, 'weight', weight);

                      detailsModel.setCellValue(curRowIndex, 'define1', define1);
                      detailsModel.setCellValue(curRowIndex, 'define2', define2);
                      detailsModel.setCellValue(curRowIndex, 'define3', define3);
                      detailsModel.setCellValue(curRowIndex, 'define4', define4);
                      detailsModel.setCellValue(curRowIndex, 'define5', define5);
                      detailsModel.setCellValue(curRowIndex, 'define6', define6);
                      detailsModel.setCellValue(curRowIndex, 'define7', define7);
                      detailsModel.setCellValue(curRowIndex, 'define8', define8);
                      detailsModel.setCellValue(curRowIndex, 'define9', define9);
                      detailsModel.setCellValue(curRowIndex, 'define10', define10);
                      detailsModel.setCellValue(curRowIndex, 'define11', define11);
                      detailsModel.setCellValue(curRowIndex, 'define12', define12);
                      detailsModel.setCellValue(curRowIndex, 'define13', define13);
                      detailsModel.setCellValue(curRowIndex, 'define14', define14);
                      detailsModel.setCellValue(curRowIndex, 'define15', define15);
                      detailsModel.setCellValue(curRowIndex, 'define16', define16);
                      detailsModel.setCellValue(curRowIndex, 'define17', define17);
                      detailsModel.setCellValue(curRowIndex, 'define18', define18);
                      detailsModel.setCellValue(curRowIndex, 'define19', define19);
                      detailsModel.setCellValue(curRowIndex, 'define20', define20);
                      detailsModel.setCellValue(curRowIndex, 'define21', define21);
                      detailsModel.setCellValue(curRowIndex, 'define22', define22);
                      detailsModel.setCellValue(curRowIndex, 'define23', define23);
                      detailsModel.setCellValue(curRowIndex, 'define24', define24);
                      detailsModel.setCellValue(curRowIndex, 'define25', define25);
                      detailsModel.setCellValue(curRowIndex, 'define26', define26);
                      detailsModel.setCellValue(curRowIndex, 'define27', define27);
                      detailsModel.setCellValue(curRowIndex, 'define28', define28);
                      detailsModel.setCellValue(curRowIndex, 'define29', define29);
                      detailsModel.setCellValue(curRowIndex, 'define30', define30);
                    } else {
                      cb.utils.alert("录入的批次 [" + batchno + "] 无法正确解析！", 'error');
                      return;
                    }
                  } else {
                    cb.utils.alert("录入的批次 [" + batchno + "] 无法正确解析！", 'error');
                    return;
                  }
                });
              }
						}
				}
			});

			// ====== 处理盘点机生成的附件 ===================================================================================
			viewmodel.get("btnAttachment").on('click', function() {
				const eleInput = document.createElement('input');
				eleInput.type = 'file';
				eleInput.style.display = 'none';
				eleInput.onchange = function(event) {
					const reader = new FileReader();
					reader.onload = (e) => {
						onAttachment(e.target.result);
					};
					reader.readAsText(event.target.files[0]);
					document.body.removeChild(eleInput);
				};
				document.body.appendChild(eleInput);
				eleInput.click();
			});

			var onAttachment = function(data) {
				// ====== 正数正则 ======
				const regExp = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
				// const regExp = /^[1-9]\d*\.\d*|0\.\d*[1-9]\d*|0?\.0+|0$/;
				// const regExp = /^\+?[1-9][0-9]*$/; // ====== 实盘数量不再限定为正整数，可以是小数 ======

				var queryProductProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/bill/ref/getBarcodeResult.do',
						method: 'POST'
					}
				});
				var params = {
					isReturn: 0,
					keyword: ''
				};

				var dataMap = new Map();
				var curBarCode = null;
				var curNumber = null;

				var fData = data.replace(/\r+\n+/g, '__BirdMark__');
				var lines = fData.split('__BirdMark__');
				if(lines.length <= 0) {
					cb.utils.alert("所选文件没有任何数据！", 'error');
					return;
				}

				for(var i = 0; i < lines.length; i++) {
					var line = lines[i].trim();
					var strs = line.split(/\s+|\t+/g);

					if(strs.length <= 0) {
						continue;
					}

					if(strs.length > 2) {
						cb.utils.alert("数据格式错误！", 'error');
						dataMap = null;
						break;
					}

					if(strs.length == 1) {
						curBarCode = strs[0];

						if(curBarCode.trim() == "") {
							continue;
						}

						curNumber = 1;
					} else {
						curBarCode = strs[0];
						curNumber = strs[1];

						if(!regExp.test(curNumber)) {
							cb.utils.alert("数据格式错误！", 'error');
							dataMap = null;
							break;
						}
					}

					curNumber = parseFloat(curNumber);
					dataMap = pushNewData(dataMap, curBarCode, curNumber);
				}

				var curMainId = viewmodel.get("id").getValue();

				for(let [key, value] of dataMap) {
					params.keyword = key;

					queryProductProxy.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined || JSON.stringify(result) == "{}") {
							cb.utils.alert("条码/商品/SKU [" + key + "] 无法解析！", 'error');
							return;
						}

						let pData = result.data[0];
						let isBatchManage = pData.isBatchManage;
						let resultSku = pData.productskus["0"].skuId;
						let batchno = isBatchManage ? pData.productskus[0].batchno : "_invalid_value_";

						if(isWithinRange(pData, 'productQueryService')) {
							var targetRow = findRow(resultSku, isBatchManage, batchno);

							if(targetRow != -1) {
								let newQuantity = null;
								let tempQty = detailsModel.getCellValue(targetRow, 'quantity');

								if(null == tempQty || tempQty === undefined) {
									newQuantity = 1;
								} else {
									newQuantity = parseFloat(tempQty) + value;
								}

								detailsModel.setCellValue(targetRow, "quantity", newQuantity, false, false);
							} else {
								appendNewRow(curMainId, result, value);
							}
						}
					});
				}
			};

			// ====== 内部方法，用于构造包含导入数据的Map ======
			var pushNewData = function(map, key, value) {
				if(map.size <= 0 || !map.has(key)) {
					map.set(key, value);
				} else {
					var oldValue = map.get(key);
					map.set(key, parseFloat(value) + parseFloat(oldValue));
				}

				return map;
			};

			// ====== 更换商店后刷新仓库 =====================================================================================
			viewmodel.get("store_name").on('afterValueChange', function(data) {
				var queryStoreProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/bill/ref/getWarehouseByStore',
						method: 'POST'
					}
				});
				var params = {
					token: '28f9169d2e2a491bb1804138e4357e29',
					store: data.value.id
				};

				queryStoreProxy.settle(params, (err, result) => {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}

					if(result === undefined) {
						cb.utils.alert("没有查询当前选择店铺的默认仓库！", 'error');
					} else {
						viewmodel.get("warehouse").setValue(result.warehouse);
						viewmodel.get("warehouse_name").setValue(result.warehouse_name);
					}
				});
			});

			// ====== 判断该商品是否在盘点范围之内 ======
			// ====== Bird Added on 2018-03-21 ======
			var isWithinRange = function(pData, dataType = 'detailLine') {
				var ret = false;
				var checkRange = viewmodel.get('storeCheckRange').getValue();

				switch(checkRange) {
					// ====== 整仓盘点 ======
					case 0:
						ret = true;
						break;

						// ====== 指定品类 ======
					case 1:
						ret = true;

						/* ====== 2018-03-26 不在限制品类 ======
						var planProductClasses = planViewModel.get('productClass').getValue();

						var curRroductClass = null;
						var curPath = pData.ppath;
						var curPathClasses = null;

						switch(dataType) {
						    case 'detailLine':
						        curRroductClass = pData.productClassId;
						        break;
						    case 'productQueryService':
						        curRroductClass = pData.pid;
						}

						curPathClasses = curPath.split("|");

						for(var i = 0; i < planProductClasses.length; i++) {
						    var tempClass = planProductClasses[i].productClass;

						    var foundClass = curPathClasses && curPathClasses.find((value) => {
						        return value === tempClass.toString();
						    });

						    if(foundClass !== undefined) {
						        ret = true;
						        break;
						    }
						}

						if(!ret) {
						    cb.utils.alert("当前商品超出计划的商品分类！", 'error');
						}
						*/

						break;

						// ====== 指定商品 ======
					case 2:
						ret = true;

						/* ====== 2018-03-29 不在限制商品 ======
						var detailDatas = detailsModel.getData();
						var curProduct = pData.id;
						var curLength = detailDatas.length - 1;

						for(var i = 0; i < curLength; i++) {
						    var tempProduct = detailDatas[i].product;
						    if(curProduct == tempProduct) {
						        ret = true;
						        break;
						    }
						}

						if(!ret) {
						    cb.utils.alert("当前商品超出计划的商品范围！", 'error');
						}
						*/
				}

				return ret;
			};

			// ====== 实盘单据时间不得小于盘点计划开始时间 ======
			viewmodel.get("vouchdate").on('afterValueChange', function(data) {
				var ret = true;

				var planCheckStartDate = planViewModel.get('checkStartTime').getValue();

				var minDate = Date.parse(planCheckStartDate);
				var thisDate = Date.parse(data.value);

				if(null != thisDate && minDate > thisDate) {
					cb.utils.alert('单据的业务时间不得小于盘点计划开始时间', 'warning');
					viewmodel.get('vouchdate').setValue(data.oldValue);
					ret = false;
				}

				return ret;
			});

			//仓库变化之后，查询是否存在未复核的快速盘点，如果存在，不允许值变化
			viewmodel.get("warehouse_name").on('beforeValueChange', function(data) {
				if(data.value) {
					var wareh = data.value.id;
					var params = {
						wareh: wareh
					};
					var existStoreCheck = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/existStoreCheck',
							method: 'POST'
						}
					});

					var promise = new cb.promise();
					existStoreCheck.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}

						if(result === undefined) {
							cb.utils.alert("查询快速盘点异常！", 'error');
							return;
						}

						if(result != null && result != undefined && result !== '') {
							if(result == false || result == 'false') {
								promise.resolve();
							} else {
								cb.utils.alert("该仓库下存在未复核的快速盘点单，不允许新增实盘单！", 'error');
							}
						}

					});
					return promise;
				}
			});

		}
	};

	try {
		module.exports = ST_st_storecheck_VM_Extend;
	} catch(error) {

	}
	return ST_st_storecheck_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckreality_VM.Extend.js